import React from "react";
import { motion } from "framer-motion";
import { useAuth } from "../Auth/AuthContext";

const AboutPublishers = () => {
  const { authState } = useAuth();
  const user = authState.user;
  const role = authState.roles;
  const isAdmin = role === "Admin";

  const notApproved =
    !isAdmin && user && user.isApprovedByAdmin === false;

  if (notApproved) {
    return (
      <motion.section
        className="min-h-screen flex items-center justify-center bg-yellow-50 px-4 py-16"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <div className="max-w-xl text-center bg-white p-8 rounded-2xl shadow-xl border border-yellow-200">
          <motion.h2
            className="text-3xl font-bold text-yellow-700 mb-4"
            initial={{ y: -20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6 }}
          >
            Your Account is Not Approved Yet 🚫
          </motion.h2>
          <motion.p
            className="text-gray-700 text-lg"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2, duration: 0.6 }}
          >
            Once an admin approves your account, please sign in again to access all dashboard features. If you've recently registered, kindly wait for approval or contact support.
          </motion.p>
        </div>
      </motion.section>
      
    );
  }

  // Default UI for approved publishers or admins
  return (
    <motion.section
      className="min-h-screen flex items-center justify-center bg-gradient-to-b from-white via-slate-50 to-slate-100 px-4 py-16"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <div className="max-w-7xl w-full mx-auto text-center">
        <motion.h2
          className="text-4xl font-bold text-gray-800 mb-6"
          initial={{ y: -20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.6 }}
        >
          Welcome to the Publisher Dashboard
        </motion.h2>

        <motion.p
          className="text-lg text-gray-600 max-w-3xl mx-auto mb-12"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.6 }}
        >
          Monetize-Media empowers publishers with advanced tools and insights to optimize ad revenue. Our dashboard provides real-time data, performance analytics, and AI-driven recommendations to help publishers maximize their earnings.
        </motion.p>

        <div className="flex flex-col md:flex-row items-center justify-center gap-10">
          <motion.img
            src="./Images/publishers_dashboard.png"
            alt="Publishers Dashboard"
            className="w-full max-w-md rounded-2xl shadow-xl"
            initial={{ scale: 0.95, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.3 }}
          />
          <motion.div
            className="text-left max-w-md bg-white p-6 rounded-xl shadow-md border border-gray-200"
            initial={{ x: 40, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            <h3 className="text-2xl font-semibold text-gray-700 mb-4">
              What You Get:
            </h3>
            <ul className="list-disc list-inside text-gray-600 space-y-2">
              <li>Ad performance insights</li>
              <li>Customizable reporting tools</li>
              <li>Exclusive monetization strategies</li>
            </ul>
          </motion.div>
        </div>
      </div>
    </motion.section>
  );
};

export default AboutPublishers;
